
import { toast } from "react-toastify"
import { useDispatch, useSelector } from "react-redux"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import customAPI from "./customAPI.js"
import { GetLoginCredentialDb, linksUrl } from "../constants/enum.js"
import { useNavigate } from "react-router-dom"


export const usePost = ({
  queryKey,
  url,
  resetValues = () => { },
  successMessage = "",
  onSuccessTasks = () => { },
}) => {
  const { token, user, tokenExpiry } = useSelector((state) => state.auth)
  const { yearId, compCode } = useSelector((state) => state.company)
  let navi = useNavigate();
  if (tokenExpiry && tokenExpiry != "") {
    const currentTime = new Date().getTime() / 1000;
    if (currentTime > tokenExpiry) {
      if (!toast.isActive("tknExpiremsg") && !toast.isActive('tknExpire') && !toast.isActive('toast_tkexp') && !toast.isActive('toast_tknf')) {
        console.log("hi")
        // navi(linksUrl.login)
        // toast.error("Token Expired", {
        //   position: "top-center",
        //   toastId: "toast_tkexp",
        //   //onClose: () => navi(linksUrl.login)
        // })
      }
    }
  }
  const user_Login = GetLoginCredentialDb(user, yearId)

  const queryClient = useQueryClient()
  const {
    mutate,
    isPending,
    isError,
    data = [],
  } = useMutation({

    mutationFn: async ({ data: newData }) => {

      const param = { ...newData, db_user: user_Login }

      const { data } = await customAPI.post(url, param, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })

      return data.data
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [queryKey] })
      if (successMessage) {
        toast.success(successMessage)
      }
      resetValues()
      onSuccessTasks(data)
    },
    onError: (error) => {
     

      if (!toast.isActive("tknExpiremsg") && !toast.isActive('tknExpire') && !toast.isActive('toast_tknf') && !toast.isActive('toast_tkexp')) {
        // if (error.response.data.message == 'Token is invalid') {
        //   navi(linksUrl.login)
        // }
        // else {
        //   toast.error(error.response.data.message, {
        //     position: "top-center",
        //     // onClose: () => navi(linksUrl.login)
        //   })
        // }
        
        toast.error(error.response.data.message == "Token is Invalid" ? "Session Expired Login Again" :
          error.response.data.message, {
          position: "top-center",
          toastId: "toast_tknf",
          onClose: () => navi(linksUrl.login)
        })


      }
    },
  })

  return { isPending, mutate, isError, data }
}


export const usePostMutateWithSuccess = ({
  queryKey,
  url,
  resetValues = () => { },
  successMessage = "",
  onSuccessTasks = () => { },
}) => {
  const { token, user, tokenExpiry } = useSelector((state) => state.auth)
  const { yearId, compCode } = useSelector((state) => state.company)
  let navi = useNavigate();
  if (tokenExpiry && tokenExpiry != "") {
    const currentTime = new Date().getTime() / 1000;
    if (currentTime > tokenExpiry) {
      if (!toast.isActive("tknExpiremsg") && !toast.isActive('tknExpire') && !toast.isActive('toast_tkexp') && !toast.isActive('toast_tknf')) {
        //navi(linksUrl.login)
        // toast.error("Token Expired", {
        //   position: "top-center",
        //   toastId: "toast_tkexp",
        //   onClose: () => navi(linksUrl.login)
        // })
      }
    }
  }
  const user_Login = GetLoginCredentialDb(user, yearId)



  const queryClient = useQueryClient()
  const {
    mutate,
    mutateAsync,
    isPending,
    isError,
    data = [],
  } = useMutation({

    mutationFn: async ({ data: newData, onSuccess }) => {

      const param = { ...newData, db_user: user_Login }

      const { data } = await customAPI.post(url, param, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })

      return data.data
    },
    onSuccess: (data, variables) => {
      const { onSuccess } = variables;
      queryClient.invalidateQueries({ queryKey: [queryKey] })
      if (successMessage) {
        toast.success(successMessage)
      }
      resetValues()
      if (typeof onSuccess === 'function') {
        onSuccess(data);
      } else {
        // fallback to default passed in hook
        onSuccessTasks(data); // from props
      }
    },
    onError: (error) => {
      if ( !toast.isActive("tknExpiremsg") && !toast.isActive('tknExpire') && !toast.isActive('toast_tknf') && !toast.isActive('toast_tkexp')) {
        // if (error.response.data.message == 'Token is invalid') {
        //   navi(linksUrl.login)
        // }
        // else {
        //   toast.error(error.response.data.message, {
        //     position: "top-center",
        //     // onClose: () => navi(linksUrl.login)
        //   })
        // }
        toast.error(error.response.data.message == "Token is Invalid" ? "Session Expired Login Again" :
          error.response.data.message, {
          position: "top-center",
          toastId: "toast_tknf",
          onClose: () => navi(linksUrl.login)
        })
      }

    },
  })

  return { isPending, mutate, mutateAsync, isError, data }
}

export const useFetchWithBody = ({
  url,
  queryKey,
  inputData,
  manipulateData = false,
  manipulateDataFn = () => { },
}) => {
  const { token, user, tokenExpiry } = useSelector((state) => state.auth)
  const { yearId } = useSelector((state) => state.company)
  const user_Login = GetLoginCredentialDb(user, yearId)

  let navi = useNavigate();
  if (tokenExpiry && tokenExpiry != "") {
    const currentTime = new Date().getTime() / 1000;
    if (currentTime > tokenExpiry) {
      if ( !toast.isActive("tknExpiremsg") && !toast.isActive('tknExpire') && !toast.isActive('toast_tkexp') && !toast.isActive('toast_tknf')) {
        // navi(linksUrl.login)
        toast.error("Session Expired Login Again", {
          position: "top-center",
          toastId: "toast_tkexp",
          onClose: () => navi(linksUrl.login)
        })
      }
    }
  }

  const {
    isLoading,
    data = [],
    isError,
    error,
  } = useQuery({
    queryKey: [queryKey],
    queryFn: async () => {

      const param = { ...inputData, db_user: user_Login }

      const { data } = await customAPI.post(url, param, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })

      let newData = data.data
      if (manipulateData) {
        newData = manipulateDataFn(newData)
      }

      return newData
    },
  })

  // if (error && error.response.data.message == "Token is invalid") {
  //   dispatch(setLogout())
  //   window.location.href = "/login";
  //   return { isLoading, isError, data, error }
  // }
  // else
  return { isLoading, isError, data, error }
}

export const usePostLogin = ({
  queryKey,
  url,
  resetValues = () => { },
  successMessage = "",
  onSuccessTasks = () => { },

}) => {
  const { token } = useSelector((state) => state.auth)
  const navi = useNavigate();

  const queryClient = useQueryClient()
  let isShowMsg = false;
  let WarningMsg = ""
  const { mutate, isPending, isError, data = [] } = useMutation({
    mutationFn: async ({ data: newData }) => {
      //const param = { ...newData, db_user: user_Login }
      const { data } = await customAPI.post(url, newData, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })

      isShowMsg = data.isShowMsg
      WarningMsg = data.message
      return data.data
    },
    onSuccess: (data) => {

      if (!isShowMsg) {
        queryClient.invalidateQueries({ queryKey: [queryKey] })
        if (successMessage) {
          toast.success(successMessage)
        }
        resetValues()
        onSuccessTasks(data)
      }
      else {
        toast.error(WarningMsg, {
          position: "top-center",
        })
      }

    },
    onError: (error) => {
      if (error.response.data.message == 'Token is invalid') {
        navi(linksUrl.login)
      }
      else {
        toast.error(error.response.data.message, {
          position: "top-center",
          onClose: () => navi(linksUrl.login)
        })
      }
    },
  })
  return { isPending, mutate, isError, data }
}

export const useGet = ({ url, queryKey }) => {
  const { token } = useSelector((state) => state.auth)

  const {
    isLoading,
    data = [],
    isError,
  } = useQuery({
    queryKey: [queryKey],
    queryFn: async () => {
      const { data } = await customAPI.get(url, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      return data.data
    },
  })
  return { isLoading, isError, data }
}

export const useEdit = ({ queryKey, url }) => {
  const queryClient = useQueryClient()

  const { mutate: editData = [] } = useMutation({
    mutationFn: ({ id, data }) => customAPI.patch(`${url}${id}`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKey] })
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    },
  })
  return { editData }
}

export const useDelete = ({ queryKey, url, onSuccessTasks = () => { } }) => {
  const queryClient = useQueryClient()
  const { token } = useSelector((state) => state.auth)

  const { mutate, isLoading } = useMutation({
    mutationFn: ({ data = {} }) =>
      customAPI.delete(`${url}`, {
        data,
        headers: {
          Authorization: "Bearer " + token,
        },
      }),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [queryKey] })
      onSuccessTasks(data)
    },
    onError: (error) => {
      toast.error(error.response.data.message)
    },
  })
  return { mutate, isLoading }
}
































// import { toast } from "react-toastify"
// import { useDispatch, useSelector } from "react-redux"
// import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
// import customAPI from "./customAPI.js"
// import { GetLoginCredentialDb, linksUrl } from "../constants/enum.js"
// import { useNavigate } from "react-router-dom"


// export const usePost = ({
//   queryKey,
//   url,
//   resetValues = () => { },
//   successMessage = "",
//   onSuccessTasks = () => { },
// }) => {
//   const { token, user, tokenExpiry } = useSelector((state) => state.auth)
//   const { yearId, compCode } = useSelector((state) => state.company)
//   let navi = useNavigate();
//   if (tokenExpiry && tokenExpiry != "") {
//     const currentTime = new Date().getTime() / 1000;
//     if (currentTime > tokenExpiry) {
//       if (!toast.isActive('tknExpire') && !toast.isActive('toast_tkexp') && !toast.isActive('toast_tknf')) {
//         // toast.error("Token Expired", {
//         //   position: "top-center",
//         //   toastId: "toast_tkexp",
//         //   onClose: () => navi(linksUrl.login)
//         // })
//       }
//     }
//   }
//   const user_Login = GetLoginCredentialDb(user, yearId)



//   const queryClient = useQueryClient()
//   const {
//     mutate,
//     isPending,
//     isError,
//     data = [],
//   } = useMutation({

//     mutationFn: async ({ data: newData }) => {

//       const param = { ...newData, db_user: user_Login }

//       const { data } = await customAPI.post(url, param, {
//         headers: {
//           Authorization: "Bearer " + token,
//         },
//       })

//       return data.data
//     },
//     onSuccess: (data) => {
//       queryClient.invalidateQueries({ queryKey: [queryKey] })
//       if (successMessage) {
//         toast.success(successMessage)
//       }
//       resetValues()
//       onSuccessTasks(data)
//     },
//     onError: (error) => {
//       if (!toast.isActive('tknExpire') && !toast.isActive('toast_tknf') && !toast.isActive('toast_tkexp')) {
//         toast.error(error.response.data.message, {
//           position: "top-center",
//           toastId: "toast_tknf",
//           onClose: () => navi(linksUrl.login)
//         })
//       }

//     },
//   })

//   return { isPending, mutate, isError, data }
// }


// export const usePostMutateWithSuccess = ({
//   queryKey,
//   url,
//   resetValues = () => { },
//   successMessage = "",
//   onSuccessTasks = () => { },
// }) => {
//   const { token, user, tokenExpiry } = useSelector((state) => state.auth)
//   const { yearId, compCode } = useSelector((state) => state.company)
//   let navi = useNavigate();
//   if (tokenExpiry && tokenExpiry != "") {
//     const currentTime = new Date().getTime() / 1000;
//     if (currentTime > tokenExpiry) {
//       if (!toast.isActive('tknExpire') && !toast.isActive('toast_tkexp') && !toast.isActive('toast_tknf')) {
//         // toast.error("Token Expired", {
//         //   position: "top-center",
//         //   toastId: "toast_tkexp",
//         //   onClose: () => navi(linksUrl.login)
//         // })
//       }
//     }
//   }
//   const user_Login = GetLoginCredentialDb(user, yearId)



//   const queryClient = useQueryClient()
//   const {
//     mutate,
//     mutateAsync,
//     isPending,
//     isError,
//     data = [],
//   } = useMutation({

//     mutationFn: async ({ data: newData, onSuccess }) => {

//       const param = { ...newData, db_user: user_Login }

//       const { data } = await customAPI.post(url, param, {
//         headers: {
//           Authorization: "Bearer " + token,
//         },
//       })

//       return data.data
//     },
//     onSuccess: (data, variables) => {
//       const { onSuccess } = variables;
//       queryClient.invalidateQueries({ queryKey: [queryKey] })
//       if (successMessage) {
//         toast.success(successMessage)
//       }
//       resetValues()
//       if (typeof onSuccess === 'function') {
//         onSuccess(data);
//       } else {
//         // fallback to default passed in hook
//         onSuccessTasks(data); // from props
//       }
//     },
//     onError: (error) => {
//       if (!toast.isActive('tknExpire')  && !toast.isActive('toast_tknf') && !toast.isActive('toast_tkexp')) {
//         toast.error(error.response.data.message, {
//           position: "top-center",
//           toastId: "toast_tknf",
//           onClose: () => navi(linksUrl.login)
//         })
//       }

//     },
//   })

//   return { isPending, mutate, mutateAsync, isError, data }
// }
// export const useFetchWithBody = ({
//   url,
//   queryKey,
//   inputData,
//   manipulateData = false,
//   manipulateDataFn = () => { },
// }) => {
//   const { token, user, tokenExpiry } = useSelector((state) => state.auth)
//   const { yearId } = useSelector((state) => state.company)
//   const user_Login = GetLoginCredentialDb(user, yearId)

//   let navi = useNavigate();
//   if (tokenExpiry && tokenExpiry != "") {
//     const currentTime = new Date().getTime() / 1000;
//     if (currentTime > tokenExpiry) {
//       if (!toast.isActive('tknExpire') && !toast.isActive('toast_tkexp') && !toast.isActive('toast_tknf')) {
//         // toast.error("Token Expired", {
//         //   position: "top-center",
//         //   toastId: "toast_tkexp",
//         //   onClose: () => navi(linksUrl.login)
//         // })
//       }
//     }
//   }

//   const {
//     isLoading,
//     data = [],
//     isError,
//     error,
//   } = useQuery({
//     queryKey: [queryKey],
//     queryFn: async () => {

//       const param = { ...inputData, db_user: user_Login }

//       const { data } = await customAPI.post(url, param, {
//         headers: {
//           Authorization: "Bearer " + token,
//         },
//       })

//       let newData = data.data
//       if (manipulateData) {
//         newData = manipulateDataFn(newData)
//       }

//       return newData
//     },
//   })

//   // if (error && error.response.data.message == "Token is invalid") {
//   //   dispatch(setLogout())
//   //   window.location.href = "/login";
//   //   return { isLoading, isError, data, error }
//   // }
//   // else
//   return { isLoading, isError, data, error }
// }

// export const usePostLogin = ({
//   queryKey,
//   url,
//   resetValues = () => { },
//   successMessage = "",
//   onSuccessTasks = () => { },

// }) => {
//   const { token } = useSelector((state) => state.auth)
//   const navi = useNavigate();

//   const queryClient = useQueryClient()
//   let isShowMsg = false;
//   let WarningMsg = ""
//   const { mutate, isPending, isError, data = [] } = useMutation({
//     mutationFn: async ({ data: newData }) => {
//       //const param = { ...newData, db_user: user_Login }
//       const { data } = await customAPI.post(url, newData, {
//         headers: {
//           Authorization: "Bearer " + token,
//         },
//       })

//       isShowMsg = data.isShowMsg
//       WarningMsg = data.message
//       return data.data
//     },
//     onSuccess: (data) => {

//       if (!isShowMsg) {
//         queryClient.invalidateQueries({ queryKey: [queryKey] })
//         if (successMessage) {
//           toast.success(successMessage)
//         }
//         resetValues()
//         onSuccessTasks(data)
//       }
//       else {
//         toast.error(WarningMsg, {
//           position: "top-center",
//         })
//       }

//     },
//     onError: (error) => {
//       if (error.response.data.message == 'Token is invalid') {
//         navi(linksUrl.login)
//       }
//       else {
//         toast.error(error.response.data.message, {
//           position: "top-center",
//           onClose: () => navi(linksUrl.login)
//         })
//       }
//     },
//   })
//   return { isPending, mutate, isError, data }
// }

// export const useGet = ({ url, queryKey }) => {
//   const { token } = useSelector((state) => state.auth)

//   const {
//     isLoading,
//     data = [],
//     isError,
//   } = useQuery({
//     queryKey: [queryKey],
//     queryFn: async () => {
//       const { data } = await customAPI.get(url, {
//         headers: {
//           Authorization: "Bearer " + token,
//         },
//       })
//       return data.data
//     },
//   })
//   return { isLoading, isError, data }
// }

// export const useEdit = ({ queryKey, url }) => {
//   const queryClient = useQueryClient()

//   const { mutate: editData = [] } = useMutation({
//     mutationFn: ({ id, data }) => customAPI.patch(`${url}${id}`, data),
//     onSuccess: () => {
//       queryClient.invalidateQueries({ queryKey: [queryKey] })
//     },
//     onError: (error) => {
//       toast.error(error.response.data.message)
//     },
//   })
//   return { editData }
// }

// export const useDelete = ({ queryKey, url, onSuccessTasks = () => { } }) => {
//   const queryClient = useQueryClient()
//   const { token } = useSelector((state) => state.auth)

//   const { mutate, isLoading } = useMutation({
//     mutationFn: ({ data = {} }) =>
//       customAPI.delete(`${url}`, {
//         data,
//         headers: {
//           Authorization: "Bearer " + token,
//         },
//       }),
//     onSuccess: (data) => {
//       queryClient.invalidateQueries({ queryKey: [queryKey] })
//       onSuccessTasks(data)
//     },
//     onError: (error) => {
//       toast.error(error.response.data.message)
//     },
//   })
//   return { mutate, isLoading }
// }


